import type { ISessionRepository, SessionCreateInput } from '../repositories/ISessionRepository.js';
import type { SessionEntity } from '../entities/SessionEntity.js';

interface Deps { sessionRepository: ISessionRepository; }

export function createCreateSessionUseCase({ sessionRepository }: Deps) {
  return async function createSession(input: SessionCreateInput): Promise<SessionEntity> {
    return sessionRepository.create(input);
  };
}
